import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    "Economize horas toda semana",
    "Tenha tudo organizado em um único lugar",
    "Use materiais prontos para impressão",
    "Planeje melhor suas aulas",
    "Faça parte de uma comunidade de professores"
  ];

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-8">
        <div className="bg-[#FFB800] rounded-[4rem] p-12 md:p-20 flex flex-col lg:flex-row items-center gap-16 relative">
          {/* Decorative shapes */}
          <div className="absolute top-10 left-10 w-20 h-20 bg-white/20 rounded-full blur-2xl"></div>
          <div className="absolute bottom-10 right-10 w-32 h-32 bg-black/5 rounded-full blur-3xl"></div>

          <div className="lg:w-1/2">
            <span className="text-black/60 font-black uppercase tracking-widest mb-6 block">⭐ Benefícios</span>
            <h2 className="text-4xl md:text-6xl font-black text-black mb-10 leading-tight">
              Por que usar o Sora?
            </h2>
            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-4 bg-white/50 backdrop-blur p-4 rounded-2xl border border-white/30">
                  <div className="bg-black text-white rounded-full p-1">
                    <CheckCircle2 size={24} />
                  </div>
                  <span className="text-lg font-bold text-black">{benefit}</span>
                </div>
              ))}
            </div>
            <div className="mt-12 text-3xl font-black italic opacity-80">
              Mais organização. Menos sobrecarga.
            </div>
          </div>

          <div className="lg:w-1/2 relative">
             <div className="relative z-10 bg-white p-4 rounded-[3rem] shadow-2xl rotate-2">
                <img 
                  src="https://images.unsplash.com/photo-1531482615713-2afd69097998?q=80&w=2070&auto=format&fit=crop" 
                  alt="Happy teacher" 
                  className="rounded-[2.5rem] w-full"
                />
             </div>
             {/* Floating text bubbles */}
             <div className="absolute -top-6 -left-10 bg-black text-white p-4 rounded-2xl font-bold shadow-xl rotate-[-5deg] z-20">
               "Minha rotina mudou!"
             </div>
             <div className="absolute -bottom-6 -right-10 bg-purple-600 text-white p-4 rounded-2xl font-bold shadow-xl rotate-[3deg] z-20">
               "Finalmente organizada"
             </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;

